// myArray = ['test', 'test', 'test', 'test' ...]
// chunkSize = 2
// return [['test', 'test'], ['test', 'test'] ...]
export const chunkArray = (myArray: any[], chunkSize: number): any[] => {
  const chunkedArray: any[] = [];
  
  for(let i = 0; i < myArray.length; i += chunkSize) {
    chunkedArray.push(myArray.slice(i, i + chunkSize));
  }

  return chunkedArray;
}